/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { forwardRef } from 'react'

import './formvalidation-msgs.css'
import { profilevalidationmsgs } from './profile-validation-msgs-data'

const ProfileValidationMsgs = (
  {
    changeDetected,
    displayErrorPopUp,
    onClick,
    setDisplayErrorPopUp,
    updateClickPosition,
    validationField,
  }: {
    changeDetected: boolean
    displayErrorPopUp: any
    onClick: (field: any) => void
    setDisplayErrorPopUp: any
    updateClickPosition: 'Bottom' | 'Top'
    validationField: any
  },
  ref: any
) => {
  const showHideCancel = () => {
    if (updateClickPosition === 'Top') {
      setDisplayErrorPopUp({
        ...displayErrorPopUp,
        [updateClickPosition]: false,
      })
    } else {
      setDisplayErrorPopUp({
        ...displayErrorPopUp,
        [updateClickPosition]: false,
      })
    }
  }
  const notValidFields = Object.keys(validationField).filter((key) => {
    return validationField[key] === false
  })

  return (
    <div
      className='pt-2 validation-msgs mb-3 py-2 ps-2 whitebg shadow text-color5 bordered7 border-radius p-relative'
      style={{ display: !changeDetected || (changeDetected && notValidFields?.length) ? '' : 'none' }}
    >
      {changeDetected && notValidFields?.length > 0 && (
        <h2 className='px-2 title-color1 font-15 sourcesansprosemibold text-uppercase'>
          <span aria-label='Please Fill The Below Mandatory Fields' tabIndex={0}>
            Please Fill The Below Mandatory Fields
          </span>
        </h2>
      )}
      {!changeDetected && (
        <h2 className='px-2 m-0 title-color1 font-15 sourcesansprosemibold text-uppercase '>
          <span aria-label='No Changes Detected' tabIndex={0}>
            No Changes Detected
          </span>
        </h2>
      )}
      <button
        aria-label='Close'
        className='anchorclosebutton py-2 px-2 bgcolor-primary whitetext btn-border-radius3'
        onClick={showHideCancel}
        title='Close'
        type='button'
      >
        <span className='icon-close text-color1 font-10'></span>
      </button>
      {changeDetected && notValidFields?.length > 0 && (
        <ul
          // aria-live='polite'
          className='marker-color list-type-circle font-13 sourcesanspro'
          // tabIndex={0}
        >
          {changeDetected &&
            notValidFields.map((field) => (
              <li key={field}>
                <a href='#' onClick={() => onClick(field)} title={field}>
                  {profilevalidationmsgs[0][field].title}
                </a>
              </li>
            ))}
        </ul>
      )}
    </div>
  )
}
export default forwardRef(ProfileValidationMsgs)
